<template>
  <div class="app-container">
    <BjPage ref="BjPage" :label-width="'80px'" :query-params="queryParams" :col-span="colSpan" :get-action="queryApi" :serial="false" :selection="selection" @handleSelectionChange="handleSelectionChange" @showSetting="SortableTable.show" @header-dragend="SortableTable.handleHeaderDragend" @header-contextmenu="SortableTable.handleHeaderContextmenu" @afterFetchOriginalData="afterFetchOriginalData">
      <template v-slot:baseForm>
        <el-col :span="colSpan">
          <el-form-item :label="$t('billingPage.CustomerName')" prop="clientCode"> 
            <BjSelectLov v-model="queryParams.clientCode" :option-list="clientCodeActivityList" :placeholder="$t('billingPage.CustomerName')" @change="handleQuery" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('billingPage.Status')" prop="status">
            <BjSelectLov v-model="queryParams.status" :option-list="statusList" :placeholder="$t('billingPage.Status')" :clearable="false" @change="handleQuery"/>
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('billingPage.InvnetoryValue')">
            <span>{{ $number2money(totalInventoryPrice) }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('billingPage.UnpaidInvoiceAmount')">
            <span>{{ $number2money(totalUnpaidInvoice) }}</span>
          </el-form-item>
        </el-col>
      </template>
      <template v-slot:tableOperation>
        <el-col>
          <el-button type="primary" class="main-btn" @click="onAdd()">{{ $t('addText') }}</el-button>
        </el-col>
      </template>
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column v-if="col.prop !== 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center" class-name="item">
            <template slot-scope="scope">
              <template v-if="col.prop == 'clientCode'">
                <span style="color: #3173d0;">{{ scope.row.clientCode }}</span>
                <BjCopyIcon :copy="scope.row.clientCode" />
              </template>
              <template v-else-if="col.prop == 'status'">
                <el-tag :type="scope.row[col.prop] == 0 ? 'success' : 'info'">
                  {{ $t(statusList.bjGet(scope.row[col.prop])) }}
                </el-tag>
              </template>
              <template v-else-if="col.prop == 'defaultPrice'">
                <span>{{ $number2money(scope.row[col.prop]) }}</span>
              </template>
              <template v-else-if="col.prop == 'inventoryPrice'">
                <span>{{ $number2money(scope.row[col.prop]) }}</span>
              </template>
              <template v-else-if="col.prop == 'unpaidInvoice'">
                <span>{{ $number2money(scope.row[col.prop]) }}</span>
              </template>
              <template v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</template>
            </template>
          </el-table-column>
          <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || 'right'" align="center">
            <template slot-scope="props">
              <template>
                <el-button type="text" class="edit-btn" @click="onEdit(props.row)">{{ $t('editText') }}</el-button>
                <el-button type="text" class="delete-btn" @click="onDel(props.row)">{{ $t('delText') }}</el-button>
              </template>
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>
    <!-- 新增编辑弹窗 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible" width="600px" :before-close="handleClose">
      <el-form ref="form" :model="form" :rules="rules" label-width="150px">
        <el-form-item :label="$t('billingPage.CustomerName') + ' : '" prop="clientCode">
          <BjSelectLov :disabled="dialogTitle != $t('addText')" v-model="form.clientCode" :option-list="clientCodeActivityList" :placeholder="$t('billingPage.CustomerName')"/>
        </el-form-item>
        <el-form-item :label="$t('billingPage.DefaultPrice') + ' : '" prop="defaultPrice">
          <BjInputMoney v-model="form.defaultPrice"></BjInputMoney>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose">{{ $t('cancelText') }}</el-button>
        <el-button type="primary" @click="saveAmount()">{{ $t('okText') }}</el-button>
      </div>
    </el-dialog>

  </div>
</template>
<script>
import { billApi } from '@/api';
import pageMiXin from '@/utils/page-mixin.js';
const getDefaultForm = () => {
  return {
    clientCode: null,
    defaultPrice: null,
  };
};

export default {
  name: 'BusinessBillingCustomerInventoryPricing',
  components: {},
  mixins: [pageMiXin],
  data() {
    return {
      colSpan: 4,
      selection: true,
      queryApi: billApi.getCustomerInventoryPricing,
      queryParams: {
        clientCode: '',
        status: '',
      },
      statusList: [
        { label: this.$t('billingPage.Healthy'), value: '0' },
        { label: this.$t('billingPage.Risky'), value: '1' },
      ],
      labelList: [
        { label: this.$t('billingPage.CustomerName'), prop: 'clientCode', isCheck: true, disabled: false },
        { label: this.$t('billingPage.DefaultPrice'), prop: 'defaultPrice', isCheck: true, disabled: false },
        { label: this.$t('billingPage.InventoryPrice'), prop: 'inventoryPrice', isCheck: true, disabled: false },
        { label: this.$t('billingPage.UnpaidInvoice'), prop: 'unpaidInvoice', isCheck: true, disabled: false },
        { label: this.$t('billingPage.Status'), prop: 'status', isCheck: true, disabled: false },
        { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width:160 },
      ],
      // 库存金额
      totalInventoryPrice:0.00,
      // 未结清账单金额
      totalUnpaidInvoice:0.00,

      // 弹窗相关数据
      dialogTitle:null,
      dialogFormVisible: false,
      form: getDefaultForm(),
      rules: {
        clientCode: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
        defaultPrice: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
      },
    };
  },
  methods: {
    onAdd(){
      this.dialogTitle = this.$t('addText')
      this.dialogFormVisible = true;
    },
    onEdit(row){
      this.dialogTitle = this.$t('editText')
      this.dialogFormVisible = true;
      this.form = JSON.parse(JSON.stringify(row));
    },
    // 保存弹窗数据 并 关闭编辑弹窗
    saveAmount() {
      this.$refs.form.validate(valid => {
        if (valid) {
          if(this.form.defaultPrice == '0.00'){return this.msgError(`${this.$t('inputText')} ${this.$t('billingPage.DefaultPrice')}`);}
          if(!this.form.id){
            billApi.addCustomerInventoryTotal({clientCode: this.form.clientCode, defaultPrice: this.form.defaultPrice}).then(res => {
              if(res.code == 200 || res.data == true){
                this.msgSuccess(this.$t('toast.operationSuccessText'));
                this.handleClose()
                this.reFresh();
              }
            });
          }else{
            billApi.updateCustomerInventoryTotal({id:this.form.id, clientCode: this.form.clientCode, defaultPrice: this.form.defaultPrice}).then(res => {
              if(res.code == 200 || res.data == true){
                this.msgSuccess(this.$t('toast.operationSuccessText'));
                this.handleClose()
                this.reFresh();
              }
            });
          }
        }
      })
    },
    /** 关闭弹窗 清空数据 */
    handleClose() {
      this.form = getDefaultForm();
      this.dialogFormVisible = false;
      this.$refs.form.resetFields();
    },
    // 删除按钮
    onDel(row) {
      this.$confirm(this.$t('toast.deletionConfirmationText'), this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      })
        .then(() => {
          billApi.deleteCustomerInventoryTotal({id: row.id}).then(res => {
            if(res.code == 200 || res.data == true){
              this.msgSuccess(this.$t('toast.operationSuccessText'));
              this.reFresh();
            }
          });
        })
        .catch(() => { });
    },
    // 列表接口触发后 获取两个金额显示：库存货物金额，未支付金额
    afterFetchOriginalData(res) {
      this.totalInventoryPrice = res.totalInventoryPrice
      this.totalUnpaidInvoice = res.totalUnpaidInvoice
      this.$nextTick(() => {
        this.$refs.BjPage.tableData = res.content;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.el-icon-s-flag {
  float: right;
  line-height: 34px;
}

.ts-divider {
  padding: 5px 0;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
}
</style>
